module.exports = __webpack_public_path__ + "img/Icon_energie-01.0fa1d98c.png";